import React from "react";
import FlowReachLogo from "../../assets/images/FlowReachLogo.png";

const HustleBotLogo = () => (
  <div className="products__logo products__logo--hustlebot" aria-hidden="true">
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="transparent"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6213 0L6.54419 7.01231L16.4214 24H24.5765L10.6213 0Z"
        fill="#232F5E"
      />
      <path
        d="M4.54459 14.975C2.03441 14.975 0 16.995 0 19.4875V24.0001H4.54459C7.05477 24.0001 9.08918 21.98 9.08918 19.4875C9.08918 16.996 7.05477 14.975 4.54459 14.975Z"
        fill="#2D4C9C"
      />
    </svg>
  </div>
);

const CarePlannerLogo = () => (
  <div
    className="products__logo products__logo--careplanner"
    aria-hidden="true"
  >
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="bg"
          x1="0"
          y1="0"
          x2="64"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stop-color="#7C6CFF" />
          <stop offset="100%" stop-color="#6256E8" />
        </linearGradient>
      </defs>

      <rect x="2" y="2" width="60" height="60" rx="16" fill="url(#bg)" />

      <text
        x="32"
        y="42"
        text-anchor="middle"
        font-family="Inter, Arial, sans-serif"
        font-size="34"
        font-weight="700"
        fill="#FFFFFF"
      >
        C
      </text>
    </svg>
  </div>
);

const products = [
  {
    name: "CarePlanner.ai",
    Logo: CarePlannerLogo,
    location: "Canada",
    description:
      "Architected & lead the development of an innovative pharmacy management system to help pharmacies optimize inventory, pricing, & patient care.",
    highlights: [
      "➤ AI-powered health analysis",
      "➤ Prescription risk & suitability checks",
      "➤ Personalized, proactive patient care",
    ],
    // status: "Raising Funds",
    statusNote: null,
    link: "https://careplanner.ai/"
  },
  // {
  //   name: "FlowReachApp",
  //   Logo: FlowReachLogo,
  //   location: "Virginia, US",
  //   description:
  //     "Architected & lead the development of an innovative cold email outreach platform to help businesses find prospects, personalize campaigns, and scale outbound efforts.",
  //   highlights: [
  //     "➤ Used by Sony, Stripe, and more",
  //     "➤ 100+ active businesses"
  //   ],
  //   link: "https://flowreachapp.com/"
  // },
  {
    name: "HustleBot.ai",
    Logo: HustleBotLogo,
    location: "California, US",
    description:
      "Architected & lead the development of an innovative cold email outreach platform to help businesses find prospects, personalize campaigns, and scale outbound efforts.",
    highlights: [
      "➤ 1M+ email sends per day",
      "➤ 500+ active campaigns"
    ],
    link: "https://hustlebot.ai/"
  },
];

const Products = () => {
  return (
    <section className="products" id="products">
      <div className="container">
        <div className="products__inner">
          <span className="products__label"><b>From Zero to One</b></span>
          <h2 className="products__heading">PRODUCTS I BUILT & SCALED</h2>

          <div className="products__grid">
            {products.map((product) => (
              <div className="products__card" key={product.name}>
                <div className="products__card-top">
                  <div className="products__card-brand">
                    {product.name === "FlowReachApp" ? (
                      <img
                        className="products__logo products__logo--img"
                        src={product.Logo}
                        alt={`${product.name} logo`}
                      />
                    ) : (
                      <product.Logo />
                    )}
                    <div className="products__card-title-info">
                      <a className="products__card-name" href={product.link} target="_blank">{product.name} {" "}↗</a>
                      <span className="products__card-location">{product.location}</span>
                    </div>
                  </div>
                </div>

                <p className="products__card-desc">{product.description}</p>

                {product.statusNote && (
                  <p className="products__card-note">{product.statusNote}</p>
                )}

                <ul className="products__highlights">
                  {product.highlights.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="products__cta">
            <a
              href="https://calendly.com/connect-with-ashish-subedi"
              className="btn btn--outline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Start a project
            </a>
            <a
              href="#services"
              className="btn btn--outline"
            >
              Explore Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
